<ion-slides *ngIf="challengeSteps" class="challenge__nav" [options]="{ slidesPerView: 'auto', spaceBetween: 16 }">
  <ion-slide
    *ngFor="let step of challengeSteps"
    class="challenge__nav__item"
    [class.--active]="step.id === selected?.id"
    (click)="stepChanged.emit(step)"
  >
    <div class="challenge__nav__item__icon" [innerHTML]="step.emoji"></div>
    <div class="challenge__nav__item__text" [innerHTML]="step.name"></div>
  </ion-slide>
</ion-slides>

<div class="challenge">
  <ng-content></ng-content>
</div>
